import { render, staticRenderFns } from "./estates-list.vue?vue&type=template&id=05b7f7ca&scoped=true"
import script from "./estates-list.vue?vue&type=script&lang=js"
export * from "./estates-list.vue?vue&type=script&lang=js"
import style0 from "./estates-list.vue?vue&type=style&index=0&id=05b7f7ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7f7ca",
  null
  
)

export default component.exports